import type { Login } from "../types/Login.js";
import { authenticateUser } from "./authenticate-user.js";
import { getAuthenticatedUser } from "./get-authenticated-user-data.js";
import { storageKey } from "./storage-keys.js";
import { storageService } from "./storage-service.js";

export const login: Login = async ({ password, username }) => {
  // TODO: error handling?
  // We may not need it if this is a tracked promise...
  const { token } = await authenticateUser({ password, username });

  storageService.save(storageKey.token, token);

  const userResult = await getAuthenticatedUser();

  storageService.save(storageKey.user, userResult, true);

  return userResult;
};
